module.exports = ".ui-autocomplete-input-token {\n  padding: 0px;\n}\n.ui-autocomplete-multiple-container {\n  width: 100%;\n}"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./src/assets/primeng/autocomplete/css/primeng.autocomplete.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./src/assets/primeng/autocomplete/css/primeng.autocomplete.css
// module chunks = styles